// generated by the plop

import { PROGRESS_STATUSES } from 'symbols';
import { MediatorModel } from '../../symbols';

export interface MediatorsStateModel {
  mediatorList: MediatorModel[];
  loadMediatorStatus: PROGRESS_STATUSES;
}

export const MEDIATORS_STATE_DEFAULT: MediatorsStateModel = {
  mediatorList: [],
  loadMediatorStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
